import React, {Fragment} from "react";
import classNames from 'classnames';
import Button from "../Button";
import Modal from "../../layout/Modal";
import isEqual from "lodash-es/isEqual";

const MjColorScheme = {
    onAttributeChanged: (attributeNodes, attributeName, attribute) => {
        if (attribute.current || attribute.default) {
            attributeNodes[0].setAttribute("current", attribute.current || attribute.default);
        } else {
            attributeNodes[0].removeAttribute("current");
        }
    },
    parse: async (attributeNodes) => {
        const colorSchemes = {};
        const nodes = {};
        let first = null;
        let def = null;
        let current = null;
        attributeNodes.forEach((attributeNode) => {

            first = first || attributeNode.getAttribute("current") || attributeNode.getAttribute("default");
            def = def || attributeNode.getAttribute("default");
            current = current || attributeNode.getAttribute("current") || attributeNode.getAttribute("default");

            attributeNode.childNodes.forEach((schemeNode) => {
                if (schemeNode.nodeType !== Node.TEXT_NODE) {
                    colorSchemes[schemeNode.getAttribute("name")] = {};
                    nodes[schemeNode.getAttribute("name")] = [];
                    schemeNode.childNodes.forEach((s) => {
                        if (s.nodeType !== Node.TEXT_NODE) {
                            nodes[schemeNode.getAttribute("name")].push(s);
                        }
                    });
                }
            });
        });
        def = def || first;
        current = current || first;
        (nodes[current] || []).forEach((style) => {
            if (style.nodeName === "mj-style") {
                attributeNodes[0].parentNode.parentNode.appendChild(style);
            } else {
                attributeNodes[0].parentNode.appendChild(style);
            }
        });
        attributeNodes.forEach((attributeNode) => {
            attributeNode.parentNode.removeChild(attributeNode);
        });
        return {colorSchemes, current, default: def};
    },
    editor: (props) => {
        return <div className="schemes">
            {Object.keys(props.attribute.colorSchemes).map((schemeName) => {
                return <span className={classNames("scheme", {active: props.attribute.current === schemeName})} onClick={() => {
                    props.saveChanges("current", schemeName);
                }}>{schemeName}</span>
            })}
        </div>;
    }
};

export default class AttributeEditor extends React.Component {

    static alias = {
        "mj-color-scheme": "Színséma"
    };

    static attributes = {
        "mj-color-scheme": MjColorScheme,
    };

    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            attribute: this.props.attribute
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.attribute, prevProps.attribute)) {
            this.setState({attribute: this.props.attribute});
        }
    }

    render() {
        return <div className="attribute">
            <div className="data">
                <div className="name">{AttributeEditor.alias[this.props.attributeName]}</div>
                {!this.props.disabled && <Button onClick={() => this.setState({edit: true})} icon={{lib: "fas", name: "pencil-alt"}} className="edit-btn"/>}
            </div>
            {!this.props.disabled && <Modal
                size="large"
                header={AttributeEditor.alias[this.props.attributeName]}
                state={this.state.edit}
                buttons={[
                    {
                        text: 'Mégse',
                        props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            try {
                                this.setState({edit: false, attribute: this.props.attribute});
                            } catch (e) {

                            }
                        }
                    },
                    {
                        text: 'Alapértelmezett',
                        props: {color: "danger", disabled: this.props.disabled || this.props.isLoading},
                        onClick: async () => {
                            await this.props.onAttributeChanged(this.props.attributeName, {});
                            this.setState({edit: false});
                        }
                    },
                    {
                        text: 'Mehet',
                        props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || JSON.stringify(this.props.attribute) === JSON.stringify(this.state.attribute)},
                        onClick: async () => {
                            if (!isEqual(this.props.attribute, this.state.attribute)) {
                                await this.props.onAttributeChanged(this.props.attributeName, this.state.attribute);
                                this.setState({edit: false});
                            } else {
                                this.setState({edit: false});
                            }
                        }
                    }
                ]}
            >
                {AttributeEditor.attributes[this.props.attributeName].editor({...this.props, attribute: this.state.attribute, saveChanges: (field, value) => this.setState({attribute: {...this.state.attribute, [field]: value}})})}
            </Modal>}
        </div>;
    }
}